<template>
  <div class="detail-page reverse">
    <div class="detail-page__left">
      <CardLeftBlock
          class="clear-992"
          :backgroundImage="'product-admin'"
      >
        <template slot="body">
          <div class="card-detail-left__date">
            {{ new Date() | moment("DD MMM, YYYY") }}
          </div>
        </template>
      </CardLeftBlock>
    </div>

    <div class="detail-page__right">
      <CardRightBlock>
        <template slot="header">
          <div class="order-create__head">
            <div class="order-create__head-line">
              <div class="order-create__header-col"
                   v-bind:class="{'admin-edit-item': $store.getters.getUserProfile.isAdmin || checkImpersonate()}">
                <div class="admin-edit" @click="editTranslate([
                  'apcDelcon_backTo',
                  ])"></div>
                <router-link :to="$store.getters.GET_PATHS.reportsAPCDelcon" class="detail-page__head-back">
                  <LinkBack
                      :value="$t('apcDelcon_backTo.localization_value.value')"
                  />
                </router-link>
              </div>
            </div>
            <div class="order-create__head-title"
                 v-bind:class="{'admin-edit-item': $store.getters.getUserProfile.isAdmin || checkImpersonate()}">
              <div class="admin-edit" @click="editTranslate([
                  'apcDelcon_apcDelconConso',
                  ])"></div>
              {{$t('apcDelcon_apcDelconConso.localization_value.value')}}
            </div>
            <div class="order-create__head-txt mb-2"
                 v-bind:class="{'admin-edit-item': $store.getters.getUserProfile.isAdmin || checkImpersonate()}">
              <div class="admin-edit" @click="editTranslate([
                  'apcDelcon_apcDelconConsoCreateText',
                  ])"></div>
              {{$t('apcDelcon_apcDelconConsoCreateText.localization_value.value')}}
            </div>
          </div>
        </template>

        <template slot="body">
          <div class="order-create__section">
            <ScannerBlock
                :APCD="APCD"
                :ordersFBM="ordersFBM"
            />

            <OrdersFBMBlock
                :APCD="APCD"
                :ordersFBM="ordersFBM"
            />

            <FieldsBlock
                :APCD="APCD"
                :shippingCompanies="shippingCompanies"
            />

            <div class="order-create__row custom-row">
              <div class="custom-col custom-col--md-100"
                   v-bind:class="{'admin-edit-item': $store.getters.getUserProfile.isAdmin || checkImpersonate()}">
                <div class="admin-edit" @click="editTranslate([
                  'apcDelcon_comment',
                  ])"></div>
                <TextareaDefault
                    :label="$t('apcDelcon_comment.localization_value.value')"
                    v-model="APCD.data.comment"
                />
              </div>
            </div>
          </div>
        </template>
        <template slot="footer">
          <div class="order-create__footer">
            <div class="order-create__footer-link"
                 v-bind:class="{'admin-edit-item': $store.getters.getUserProfile.isAdmin || checkImpersonate()}">
              <div class="admin-edit" @click="editTranslate([
                  'common_cancel',
                  ])"></div>
              <router-link :to="$store.getters.GET_PATHS.reportsAPCDelcon"
                           class="site-link site-link--alt"
              >
                {{$t('common_cancel.localization_value.value')}}
              </router-link>

            </div>

            <div class="order-create__footer-btn ml-auto"
                 v-bind:class="{'admin-edit-item': $store.getters.getUserProfile.isAdmin || checkImpersonate()}">
              <div class="admin-edit" @click="editTranslate([
                  'common_create',
                  ])"></div>
              <MainButton
                  class="order-create__footer-btn-i"
                  :value="$t('common_create.localization_value.value')"
                  @click.native="$emit('saveAPCDelcon')"
              />
            </div>
          </div>
        </template>
      </CardRightBlock>
    </div>

  </div>
</template>

<script>
  import MainButton from "../../../../../UI/buttons/MainButton/MainButton";
  import CardLeftBlock from "../../../../../coreComponents/CardLeftBlock/CardLeftBlock.vue";
  import CardRightBlock from "../../../../../coreComponents/CardRightBlock/CardRightBlock.vue";
  import LinkBack from "../../../../../UI/buttons/LinkBack/LinkBack";
  import TextareaDefault from "../../../../../UI/textarea/TextareaDefault/TextareaDefault";
  import {mixinDetictingMobile} from "../../../../../../mixins/mobileFunctions";
  import FieldsBlock from "../../chunks/FieldsBlock";
  import OrdersFBMBlock from "../../chunks/OrdersFBMBlock";
  import ScannerBlock from "../../chunks/ScannerBlock";

  export default {
    name: "APCDelconCreateAdmin",
    components: {
      OrdersFBMBlock,
      ScannerBlock,
      FieldsBlock,
      MainButton,
      CardLeftBlock,
      CardRightBlock,
      LinkBack,
      TextareaDefault,
    },

    mixins: [mixinDetictingMobile],

    props: {
      APCD: Object,
      ordersFBM: Array,
      shippingCompanies: Array,
    },

    data(){
      return{
        options: [{}],
        valueQuantity: 100,
        comment: 'Please be careful with the vase inside! ',
        input01: '',
        input02: '',
        input03: '',

        optionsMulti: [
          '#49357: $100.4',
          '#49357: $10.4',
          '#49357: $59.2'
        ],
      }
    },
  }
</script>

<style scoped>
  .checkbox-scoped{
    margin-right: -5px;
  }

  td:nth-child(2){
    font-size: 12px;
    line-height: 14px;
  }
</style>
